var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BTable',_vm._g(_vm._b({attrs:{"selected":_vm.value,"headers":_vm.headers,"actions":_vm.actions,"list":_vm.list},scopedSlots:_vm._u([{key:"item.user.full_name",fn:function(ref){
var header = ref.header;
var data = ref.data;
var v = ref.value;
return [_c('router-link',{attrs:{"to":header.getRoute(data)},domProps:{"textContent":_vm._s(v)}})]}},{key:"item.storage_file.filename",fn:function(ref){
var header = ref.header;
var data = ref.data;
var v = ref.value;
return [_c('router-link',{attrs:{"to":header.getRoute(data)},domProps:{"textContent":_vm._s(v)}})]}}])},'BTable',_vm.$attrs,false),_vm.$listeners || {}))}
var staticRenderFns = []

export { render, staticRenderFns }